import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinOurTable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const address = "Unit 1, 15-17 Wingate Rd, South Windsor NSW 2756";
  const phone = "(02) 4577 6266";
  const email = "quotes@caravansmashrepairs.com.au";
  const hours = "Mon-Fri: 8:00am - 4:30pm";
  const hoursData = [{
    day: "Monday - Friday",
    time: "8:00 AM - 4:30 PM"
  }, {
    day: "Saturday",
    time: "By Appointment"
  }, {
    day: "Sunday",
    time: "Closed"
  }];
  const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(address)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  return <section data-section-id="13057" id="lets-get-you-back-on-the-road" ref={ref} className={`bg-background text-foreground py-16 lg:py-24 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 h-full">
          {}
          <div className="relative w-full h-[400px] lg:h-auto min-h-[400px] rounded-xl overflow-hidden border border-border shadow-xl bg-card/50">
            {}
            <iframe title="Location Map" width="100%" height="100%" frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0} src={mapSrc} className="w-full h-full filter grayscale contrast-125 opacity-90 hover:opacity-100 transition-opacity duration-500" style={{
            border: 0
          }} allowFullScreen />
            <div className="absolute bottom-4 left-4 z-10">
              <Button asChild variant="secondary" className="shadow-md backdrop-blur-md bg-background/90 hover:bg-secondary hover:text-secondary-foreground text-foreground border border-border rounded-sm transition-all duration-300">
                <Link to={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`} newTab>
                  <MapPin className="w-4 h-4 mr-2" />
                  Find Us in South Windsor
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-10 lg:pl-8">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-5xl font-sans font-extrabold tracking-tighter text-primary uppercase">
                Let's Get You Back on the Road
              </h2>
              <p className="text-muted-foreground text-lg max-w-md leading-relaxed">
                Our South Windsor workshop specializes in expert insurance and private caravan repairs. Contact our technical team for a professional assessment.
              </p>
            </div>

            {}
            <div className="space-y-6">
              <Link to={`tel:${phone.replace(/\D/g, "")}`} className="group flex items-center gap-4 text-2xl md:text-3xl font-sans font-bold hover:text-secondary transition-colors tracking-tight">
                <span className="p-3 rounded-md bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-all duration-300">
                  <Phone className="w-6 h-6" />
                </span>
                <span>{phone}</span>
              </Link>

              <Link to={`mailto:${email}`} className="group flex items-center gap-4 text-xl md:text-2xl font-sans font-medium hover:text-secondary transition-colors break-all tracking-tight">
                <span className="p-3 rounded-md bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-all duration-300">
                  <Mail className="w-6 h-6" />
                </span>
                <span>{email}</span>
              </Link>

              <div className="group flex items-center gap-4 text-lg md:text-xl font-sans font-medium">
                <span className="p-3 rounded-md bg-secondary/10 text-secondary">
                  <MapPin className="w-6 h-6" />
                </span>
                <span className="text-muted-foreground">{address}</span>
              </div>
            </div>

            {}
            <div className="space-y-4 pt-4">
              <div className="flex items-center gap-2 text-accent font-sans font-bold uppercase tracking-widest text-xs">
                <Clock className="w-4 h-4" />
                <span>Workshop Hours</span>
              </div>
              <div className="rounded-lg border border-border overflow-hidden bg-card/50 backdrop-blur-sm shadow-sm">
                <Table>
                  <TableHeader>
                    <TableRow className="hover:bg-transparent border-border/50">
                      <TableHead className="w-[180px] text-muted-foreground font-mono text-xs uppercase">Service Day</TableHead>
                      <TableHead className="text-right text-muted-foreground font-mono text-xs uppercase">Operational Hours</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {hoursData.map((item, i) => <TableRow key={i} data-index={i} className="hover:bg-secondary/5 border-border/50 transition-colors">
                        <TableCell className="font-sans font-bold text-foreground">
                          {item.day}
                        </TableCell>
                        <TableCell className="text-right font-mono text-muted-foreground">
                          {item.time}
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}